export function updateDataLayer(eventName: string, eventModel: any): void {
    const event = {
        event: eventName,
        event_model: eventModel
    };
    (window as any)['dataLayer']?.push(event);
}
